export default "__VITE_ASSET__CjDhAZdG__"